import './LandingPage.css';

const LandingPage = () => {
    return (
        <div className="landing-container">
            <header className="landing-header">
                <h2>About Me</h2>
            </header>

            <main>
                <section className="landing-section">
                    <p className="main-body">
                        I'm a software engineer working across the spectrum of backend technologies. This website, though, is intended to explore more philosophical and foundational questions in software.
                    </p>
                    
                    <p className="main-body last-paragraph">
                        Before software engineering, I worked in Philosophy of Science. My PhD thesis was on Empiricism in Science and the Philosophy of Science, both historically and contemporarily. The phil-sci Archive link can be found <a 
                            href="http://philsci-archive.pitt.edu/21458/" 
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            here
                        </a>, and the official document can be found <a 
                            href="https://research-information.bris.ac.uk/en/studentTheses/empiricism-in-the-philosophy-of-science" 
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            here
                        </a>. Both are under my pre-married name (Cobb), which I changed when I got married in 2022.
                        </p>
                </section>

            </main>
        </div>
    );
}

export default LandingPage;